import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/SignPunsApi";
import { CATEGORY_MEDIA_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import { getAllCategoryMedia } from "../../SignSlice";
import CategoryMediaForm from "./CategoryMediaForm";
import "react-toastify/dist/ReactToastify.css";

const CategoryMedia = () => {
  const [categoryMediaDetails, setCategoryMediaDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteCategoryMedia, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getCategoryMediaRecords,
    {
      data: categoryMediaList,
      isError: isCategoryMediaError,
      isLoading: isCategoryMediaLoading,
      isFetching: isCategoryMediaFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Category Name",
      accessor: "Category.Name",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Media Name",
      accessor: "Media.Name",
      filter: true,
      Cell: (val) => {
        return (
          <a
            href={val?.row?.original?.Media?.CloudinaryAddress}
            target="_blank"
            rel="noreferrer"
          >
            {val.value}
          </a>
        );
      },
    },
    {
      Header: "Media Description",
      accessor: "Media.Description",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Media Full Text",
      accessor: "Media.FullText",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
  ];

  const handleEditData = (CategoryMediaData) => {
    setSelectedRecord(CategoryMediaData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteCategoryMedia({
      entity: "CategoryMedia",
      id: selectedRecord.Id,
      tag: CATEGORY_MEDIA_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Category-media deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );
    getCategoryMediaRecords({
      entity: "CategoryMedia",
      top: pageSize,
      expand: { Category: {}, Media: {} },
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: CATEGORY_MEDIA_TAG,
    });
    setCategoryMediaDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isCategoryMediaLoading &&
      !isCategoryMediaError &&
      categoryMediaList &&
      !isCategoryMediaFetching
    ) {
      dispatch(getAllCategoryMedia(categoryMediaList.value));
      let CategoryMediaData = [...categoryMediaList.value];
      setCategoryMediaDetails({
        ...categoryMediaDetails,
        tableRowsData: categoryMediaList.value ? CategoryMediaData : [],
        totalData:
          categoryMediaList && categoryMediaList["@odata.count"]
            ? categoryMediaList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [
    isCategoryMediaError,
    categoryMediaList,
    isCategoryMediaLoading,
    isCategoryMediaFetching,
  ]);
  return (
    <Container>
      <Row>
        {categoryMediaDetails && (
          <DataReactTable
            reactTableData={categoryMediaDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="Category Media"
            isFetching={isCategoryMediaFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Category Media`}
          header
          btn="Success"
          message={
            <CategoryMediaForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsAddModalOpen={setIsAddModalOpen}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default CategoryMedia;
